<script setup>
import { computed } from 'vue';
import { utilsUsuarios } from 'cifra-api-js';
import Indicadores from '@/components/alumnos/Indicadores.vue';
import PopoverAlumno from '../alumnos/PopoverAlumno.vue';

const props = defineProps({
  alumno: { type: Object, required: true },
  grupo: { type: Object, default: null },
  numero: { type: Number, default: null },
  mostrarNombre: { type: Boolean, default: true },
  mostrarNumero: { type: Boolean, default: true },
  mostrarGrupo: { type: Boolean, default: false },
  indicadores: { type: Array, default: () => [] },
  linkAlumno: { type: String, default: null },
});

const wrapperTag = computed(() => (props.linkAlumno ? 'a' : 'span'));
</script>

<template>
  <div class="fila-alumno" :class="{ disabled: alumno.bloqueado }">
    <PopoverCifra
      class="popover-wrapper usuario-thumbnail-indicadores usuario-thumbnail-indicadores-sm"
      :delay="{ show: 0, hide: 100 }"
    >
      <img
        :alt="utilsUsuarios.iniciales(alumno)"
        :src="alumno.foto_url"
        :title="utilsUsuarios.fullname(alumno)"
        class="
          usuario-thumbnail
          usuario-thumbnail-sm
          img-responsive
          img-circle
          img-thumbnail
          clickable
        "
      >
      <div v-if="mostrarGrupo && grupo" class="bottom-label clickable">
        <div class="label label-default label-sm grupo-label">
          {{ grupo.etiqueta }}
        </div>
      </div>
      <template #contenido>
        <PopoverAlumno
          :alumno="alumno"
          :grupo="mostrarGrupo ? grupo : null"
          :numero="mostrarNumero ? numero : null"
          :indicadores="indicadores"
        />
      </template>
    </PopoverCifra>
    <component
      :is="wrapperTag"
      v-tooltip="mostrarNombre ? null : utilsUsuarios.fullname(alumno)"
      :href="linkAlumno || null"
      class="link-alumno"
    >
      <span v-if="mostrarNumero && numero" class="label label-default numero-alumno">
        {{ numero }}
      </span>
      <span class="nombre-alumno" :class="`numero ? '' : 'm-l-sm'`">
        {{ mostrarNombre ? utilsUsuarios.fullname(alumno) : utilsUsuarios.iniciales(alumno) }}
      </span>
    </component>
    <Indicadores :indicadores="indicadores" class="alumno-indicadores"></Indicadores>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/components/cuadernos/constantes_cuaderno.scss';

  .fila-alumno {
    position: relative;
    height: $celda-alto;
    min-height: $celda-alto;
    padding: 8px;

    &.disabled {
      background-color: $gris-disabled;
    }
  }

  .alumno-indicadores {
    position: absolute;
    display: block;
    font-size: 0.9em;
    color: $primary;
    cursor: default;
    bottom: 6px;
    right: 4px;
    :deep(.indicador) {
      margin-left: 4px;
    }
  }

  .numero-alumno {
    width: 20px;
    padding: 5px 0;
    margin: 0 0 0 8px;
    display: inline-block;
    vertical-align: top;
  }

  // Si no tiene número se nos pega el nombre
  .link-alumno {
    display: inline-block;
  }

  .nombre-alumno {
    letter-spacing: -1px;
    vertical-align: top;
    margin-left: 8px;
  }
  .grupo-label {
    font-size: 0.7em;
  }
  :deep(.popover-wrapper) {
    display: inline-block;
  }
</style>
